/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import classnames from 'classnames';
import { COLUMN_HIGHLIGHT_CLASS } from '../../../../common/engine/utilities/constants';
import {
  financialValue,
  getFinancialScale,
  isLastNPeriodLabel,
} from '../../../../common/services/textService';
import { getProjectFinancials } from '../../../project/projectSlice';
import AdjustmentControlsColumn from './AdjustmentControlsColumn';

const FinancialHeader = ({ text, showColumnHighlight = false }) => {
  const cellClassNames = classnames('financial-value', {
    [COLUMN_HIGHLIGHT_CLASS]: showColumnHighlight,
  });

  return (
    <th
      role="columnheader"
      scope="col"
      className={cellClassNames}
      data-testid="table-header-cell"
    >
      {financialValue(text)}
    </th>
  );
};

const OverallTableHeader = ({ timePeriods, documentCode, isPublishMode }) => {
  const isNwcTable = documentCode === Constants.NET_WORKING_CAPITAL;

  const financialsDisplaySettings = useSelector(
    getProjectFinancials,
    shallowEqual
  );

  return (
    <tr className="table-headers" role="row" data-testid="table-headers">
      <th
        scope="col"
        className="row-description"
        data-testid="table-header-cell"
        role="columnheader"
      >
        {getFinancialScale(financialsDisplaySettings)}
      </th>

      {timePeriods.map((periodInput, index) => {
        const period = periodInput.toString();
        const isLastNPeriod = isLastNPeriodLabel(period);
        const showColumnHighlight = isNwcTable && isLastNPeriod;

        return (
          <FinancialHeader
            text={period}
            key={`tph-${period}-${index}`}
            showColumnHighlight={showColumnHighlight}
          />
        );
      })}

      {!isPublishMode && (
        <AdjustmentControlsColumn role="columnheader" scope="col" />
      )}
    </tr>
  );
};

OverallTableHeader.propTypes = {
  timePeriods: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  documentCode: PropTypes.string,
  isPublishMode: PropTypes.bool,
};

OverallTableHeader.defaultProps = {
  documentCode: '',
  isPublishMode: false,
};

export default OverallTableHeader;
